export const zakatCalculator = {
  pageTitle: "Zakat calculator",
  eyebrow: "Give & purify",
  subtitle:
    "Estimate zakat on cash, metals, investments, and business assets. Enter what you own — 2.5% of net wealth if you are above nisab. For education only — not a fatwa.",
  inputsHeading: "What you own",
  selectHint: "Select the categories you hold, then enter amounts in USD.",
  assetsHeading: "Assets",
  liabilitiesHeading: "Liabilities",
  nisabHeading: "Nisab",
  cashLabel: "Cash",
  cashTooltip:
    "Bank balances, cash on hand, and savings you have held for a lunar year.",
  goldSilverLabel: "Gold and silver",
  goldSilverTooltip:
    "Market value of gold and silver you own, including jewelry if your school of thought includes it.",
  stocksLabel: "Stocks and funds",
  stocksTooltip: "Market value of shares, ETFs, and similar investments.",
  stocksTreatmentLabel: "How you hold them",
  traderLabel: "Trader",
  longTermLabel: "Long-term investor",
  traderHint: "Zakat is 2.5% of the full market value.",
  longTermHint:
    "Zakat is 2.5% of a portion of market value (a common 25% or 30% proxy for the company's zakatable assets).",
  proxyLabel: "Zakatable portion",
  proxyTooltip:
    "Share of market value treated as zakatable when you do not have the company's balance-sheet ratios.",
  proxy25: "25%",
  proxy30: "30%",
  businessLabel: "Business assets",
  businessTooltip: "Inventory, receivables, and other assets held for trade.",
  propertyLabel: "Property for trading",
  propertyTooltip:
    "Real estate bought to sell. A home you live in is not included.",
  loansLabel: "Loans due within a year",
  loansTooltip: "Outstanding loan payments due in the next 12 months.",
  billsLabel: "Immediate bills",
  billsTooltip: "Taxes, rent, and other bills due now.",
  wagesLabel: "Wages owed",
  wagesTooltip: "Salaries you owe to others.",
  nisabBasisLabel: "Nisab basis",
  silverLabel: "Silver",
  goldLabel: "Gold",
  goldPriceLabel: "Gold price per gram",
  silverPriceLabel: "Silver price per gram",
  goldPriceTooltip:
    "Edit if you have a current local price. Default is an illustrative USD figure.",
  silverPriceTooltip:
    "Edit if you have a current local price. Default is an illustrative USD figure.",
  calculate: "Calculate",
  reset: "Reset",
  statNetWealth: "Net zakatable wealth",
  statNisab: "Nisab ({{basis}})",
  statZakatDue: "Zakat due",
  aboveNisab: "You are above nisab. Zakat is due on net wealth.",
  belowNisab: "You are below nisab. No zakat is due on this estimate.",
  nisabSilver: "silver",
  nisabGold: "gold",
  breakdownTitle: "Breakdown",
  tableItem: "Item",
  tableAmount: "Amount",
  rowCash: "Cash",
  rowGoldSilver: "Gold and silver",
  rowStocks: "Zakatable stocks",
  rowBusiness: "Business assets",
  rowProperty: "Property for trading",
  rowAssets: "Total assets",
  rowLoans: "Loans",
  rowBills: "Immediate bills",
  rowWages: "Wages",
  rowLiabilities: "Total liabilities",
  rowNet: "Net wealth",
  disclaimer:
    "This calculator is for general illustration only and is not a fatwa. It does not track your hawl (lunar year), apply a precise per-holding balance-sheet method, or replace a qualified scholar. Metal prices are user-entered defaults. Akinda does not provide personalized religious or financial advice.",
} as const;
